/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Line_Too_Long_TitleInputs */

const en_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line Too Long`)
};

const fr_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligne trop longue`)
};

const de_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeile zu lang`)
};

const it_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linea troppo lunga`)
};

const ru_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слишком длинная строка`)
};

const es_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fila es demasiado larga`)
};

const zh_cn2_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行过长`)
};

const ja_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行が長すぎます`)
};

const hi_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइन बहुत लंबी है`)
};

const pt_pt2_embed_captions_line_too_long_title = /** @type {(inputs: Embed_Captions_Line_Too_Long_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fila muito longa`)
};

/**
* | output |
* | --- |
* | "Line Too Long" |
*
* @param {Embed_Captions_Line_Too_Long_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_line_too_long_title = /** @type {((inputs?: Embed_Captions_Line_Too_Long_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Line_Too_Long_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_line_too_long_title(inputs)
	if (locale === "de") return de_embed_captions_line_too_long_title(inputs)
	if (locale === "it") return it_embed_captions_line_too_long_title(inputs)
	if (locale === "ru") return ru_embed_captions_line_too_long_title(inputs)
	if (locale === "es") return es_embed_captions_line_too_long_title(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_line_too_long_title(inputs)
	if (locale === "ja") return ja_embed_captions_line_too_long_title(inputs)
	if (locale === "hi") return hi_embed_captions_line_too_long_title(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_line_too_long_title(inputs)
	return en_embed_captions_line_too_long_title(inputs)
});